import React, { useMemo, useState } from "react";
import { FiCheck } from "react-icons/fi";
import CollapsibleSection from "../CollapsibleSection";
import SectionSearch from "./SectionSearch";
import { filterOptions } from "./filterOptionUtils";
import styles from "../ViewOptionsPanel.module.scss";

const sameId = (a, b) => String(a ?? "") === String(b ?? "");

const MultiSelectListSection = ({
  title,
  selectedIds = [],
  options = [],
  onChange,
  showAllOption = true,
  allLabel = "Tümü",
  defaultOpen = true,
  searchPlaceholder = "Ara...",
}) => {
  const [query, setQuery] = useState("");

  const visibleOptions = useMemo(
    () => filterOptions(options, query),
    [options, query],
  );

  const toggle = (id) => {
    if (!onChange) return;
    if (id === null) {
      onChange([]);
      return;
    }
    const has = selectedIds.some((x) => sameId(x, id));
    onChange(
      has
        ? selectedIds.filter((x) => !sameId(x, id))
        : [...selectedIds, String(id)],
    );
  };

  const renderItem = (key, label, checked, onClick) => (
    <button
      key={key}
      type="button"
      role="checkbox"
      aria-checked={checked}
      className={styles.checkItem}
      onClick={onClick}
    >
      <span
        className={`${styles.checkBox} ${checked ? styles.checkBoxActive : ""}`}
      >
        {checked && <FiCheck size={10} />}
      </span>
      <span className={styles.pickerItemLabel}>{label}</span>
    </button>
  );

  return (
    <CollapsibleSection title={title} defaultOpen={defaultOpen}>
      <div className={styles.filterSectionBody}>
        {options.length > 0 && (
          <SectionSearch
            value={query}
            onChange={setQuery}
            placeholder={searchPlaceholder}
            ariaLabel={`${title} ara`}
          />
        )}
        <div
          className={`${styles.checkList} ${styles.filterScrollList}`}
          role="group"
          aria-label={title}
        >
          {showAllOption &&
            renderItem(
              "__all__",
              allLabel,
              selectedIds.length === 0,
              () => toggle(null),
            )}
          {visibleOptions.map((opt) =>
            renderItem(
              String(opt.value),
              opt.label,
              selectedIds.some((id) => sameId(id, opt.value)),
              () => toggle(opt.value),
            ),
          )}
          {query.trim() && visibleOptions.length === 0 && (
            <div className={styles.pickerHint}>Sonuç bulunamadı</div>
          )}
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default MultiSelectListSection;
